<template>
  <div class="input--group"
       v-if="inputVisible"
       :class="[fullWidth ? 'input--full' : '', toolbar ? 'input--toolbar' : '']"
       :style="fullWidthButtons ? 'width: 100%' : ''">
    <div class="input__components"
         :class="[fullWidth ? 'input--full' : '',
                  fullWidthButtons ? 'input--full-buttons' : '']"
         :style="{
              width: width + 'px'
            }">
      <label class="input__icon"
             :for="'input-' + labelId"
             v-if="lefticon"
             :class="'input__icon--' + this.size">
        <p4a-icon
          class="input__icon--left"
          :icon="leftIcon"/>
      </label>

      <transition name="fade">
        <div class="warning"
             v-if="capsLock"
             :class="[capsLock ? 'input--warning' : '',
                'warning--' + this.size]">
          <p4a-icon
            class="warning__icon"
            :icon="icon"/>
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="warning"
             v-if="capsLock"
             :class="[capsLock ? 'input--warning' : '',
                'warning--' + this.size]">
          <span class="warning__text" v-text="text">
          </span>
        </div>
      </transition>

      <transition name="fade">
        <div class="warning"
             v-if="warning.visible"
             :class="['warning--' + this.size,
                warning.visible ? 'input--invalid' : '']">
          <p4a-icon
            v-if="warning.showIcon"
            class="warning__icon"
            :icon="icon"/>
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="warning"
             v-if="warning.visible"
             :class="['warning--' + this.size,
                warning.visible ? 'input--invalid' : '']">
          <span v-if="warning.message && !warning.warningMessageOnBottom" class="warning__text" v-text="text">
          </span>
        </div>
      </transition>
      <input class="input"
             ref="input"
             :id="'input-' + labelId"
             :value="value"
             :type="type"
             :disabled="disabled"
             :placeholder="placeholder"
             :autofocus="autofocus"
             :class="[capsLock ? 'input--warning' : '',
                  'input--' + this.size,
                  warning.visible ? 'input--invalid' : '',
                  valid ? 'input--valid' : '',
                  lefticon ? 'input--left-icon' : '',
                  fullWidth ? 'input--full' : '',
                  fullWidthButtons ? 'input--full-buttons' : '',
                  disabled ? 'input--disabled' : '']"
             :style="{
              width: width + 'px'
              }"
             @keyup="detectCapslock"
             @input="userInput"
             @click="userClick"
            />
      <transition name="fade">
        <div class="input__icon input__icon--text"
             style="float: none;"
             v-if="hasText && !warning.visible"
             :class="'input__icon--' + this.size"
             @click="emptyText">
          <p4a-icon
            class="input__icon--right"
            :icon="'input-empty'"/>
        </div>
      </transition>
    </div>

    <div class="input__icons">
      <p4a-button class="input__right-button input__right-button--close"
                  v-if="closeInput"
                  :showIcon="true"
                  :onlyIconVisible="true"
                  :icon="'close'"
                  :product="''"
                  :size="'small'"
                  :disable="false"
                  :text="'Verwijderen'"
                  @click="removeInput">
      </p4a-button>
      <p4a-button class="input__right-button"
                  v-if="rightButton"
                  :showIcon="true"
                  :onlyIconVisible="true"
                  :icon="rightButton ? rightButton.icon : ''"
                  :product="''"
                  :size="'small'"
                  :disable="false"
                  :text="'Verwijderen'"
                  @click="parentFunction">
      </p4a-button>
    </div>
    <transition name="slide-fade">
      <div class="warning--bottom"
           v-if="warning.message && warning.warningMessageOnBottom"
           :class="['warning--bottom--' + this.size,
                warning.visible ? 'input--invalid' : '']" >
        <span class="warning__bottom__text" v-text="text"
              :style="{width: width + 'px'}">
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'Input',
    mounted () {
      let autofocus = document.querySelector('[autofocus]')
      if (autofocus) {
        autofocus.focus()
      }
      this.labelId = this._uid
    },
    props: {
      value: {
        type: [String, Number],
        default: '',
      },

      fullWidth: Boolean,
      fullWidthButtons: Boolean,
      width: Number,
      type: String,
      size: String,
      valid: Boolean,
      leftIcon: String,
      disabled: Boolean,
      rightButton: Object,
      closeInput: Boolean,
      placeholder: String,
      autofocus: Boolean,
      toolbar: Boolean,
      warning: {
        type: Object,
        default () {
          return {
            visible: false,
            showIcon: false,
            message: '',
            warningMessageOnBottom: false
          }
        }
      }
    },
    data () {
      return {
        capsLock: false,
        visible: false,
        inputVisible: true,
        labelId: null
      }
    },
    computed: {
      hasText () {
        return this.value && this.value !== ''
      },

      icon () {
        if (this.capsLock) {
          return 'state-warning'
        } else {
          return this.warning.visible ? 'state-error' : ''
        }
      },

      text () {
        if (this.capsLock) {
          return 'Capslock aan'
        } else {
          return this.warning.visible ? this.warning.message : ''
        }
      },

      lefticon () {
        return this.leftIcon || ''
      }
    },
    methods: {
      detectCapslock (e) {
        this.capsLock = e.getModifierState("CapsLock")
      },

      userInput (event) {
        this.$emit('input', event.target.value)
      },

      userClick () {
        this.$emit('click')
      },

      emptyText () {
        this.$emit('input', '')
      },

      parentFunction () {
        this.rightButton.method()
      },

      removeInput () {
        this.emptyText()
        this.inputVisible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .input {
    width: auto;
    min-width: rem(150);
    @extend %animate;
    padding: 0 rem(10);
    font-size: rem(14);
    border-radius: rem(2);
    box-sizing: border-box;
    border: rem(1) solid $dark-grey-background;

    &:hover { border-color: $input-hover-border; }

    &::-ms-clear { display: none; }

    &--group {
      position: relative;
      display: inline-block;
    }

    &__components {
      float: left;
      position: relative;
    }

    &__icons { float: left; }

    &:focus {
      outline: none;
      @extend %animate;
      border-color: $pending-blue;
    }

    &--valid {
      border-color: $approved-green;

      &:focus { border-color: $approved-green; }

      &:hover { border-color: $approved-green; }
    }

    &--invalid {
      border-color: $error-red;

      .warning__text {
        background-color: $error-red;

        &:after { border-right-color: $error-red; }
      }

      .warning__icon { color: $error-red; }

      &:focus { border-color: $error-red; }

      &:hover { border-color: $error-red; }
    }

    &--warning {
      border-color: $alert-orange;

      .warning__text {
        background-color: $alert-orange;

        &:after { border-right-color: $alert-orange; }
      }

      .warning__icon {
        font-size: rem(14);
        color: $alert-orange;
      }

      &:focus { border-color: $alert-orange; }

      &:hover { border-color: $alert-orange; }
    }

    &--large {
      height: rem(50);
      padding-right: rem(50);
    }

    &--medium {
      height: rem(38);
      padding-right: rem(38);
    }

    &--small {
      height: rem(25);
      padding-right: rem(25);
    }

    &__icon {
      left: rem(1);
      float: left;
      position: absolute;

      &:hover { cursor: pointer; }

      &--text { right: 0; }

      &--left {
        width: rem(50);
        height: rem(50);
        left: 0;
        bottom: 0;
        padding: rem(16);
        position: absolute;
        font-size: rem(13);
      }

      &--right {
        width: rem(50);
        height: rem(50);
        right: 0;
        bottom: 0;
        z-index: 5;
        padding: rem(16);
        position: absolute;
        font-size: rem(13);
      }

      &--small {
        top: rem(25);

        .input__icon--left {
          width: rem(25);
          height: rem(25);
          padding: rem(6);
        }

        .input__icon--right {
          width: rem(24);
          height: rem(25);
          padding: rem(6);
        }

        .icon-input-empty {
          @extend %animate;
          color: $medium-grey-font;

          &:hover {
            @extend %animate;
            color: $dark-grey-font;
          }
        }
      }

      &--medium {
        top: rem(38);

        .input__icon--left {
          width: rem(38);
          height: rem(38);
          padding: rem(12);
        }

        .input__icon--right {
          width: rem(38);
          height: rem(38);
          padding: rem(12);
        }

        .icon-input-empty {
          @extend %animate;
          color: $medium-grey-font;

          &:hover {
            @extend %animate;
            color: $dark-grey-font;
          }
        }
      }

      &--large {
        top: rem(50);

        .input__icon--left { font-size: rem(18); }

        .input__icon--right { padding: rem(16); }

        .icon-input-empty {
          @extend %animate;
          right: rem(-2);
          font-size: rem(14);
          padding-top: rem(19);
          color: $medium-grey-font;

          &:hover {
            @extend %animate;
            color: $dark-grey-font;
          }
        }
      }
    }

    &--left-icon {
      padding-left: rem(50);

      &.input--small { padding-left: rem(25); }

      &.input--medium { padding-left: rem(38); }
    }

    &__right-button {
      width: rem(25);
      height: rem(25);
      float: right;
      margin-left: rem(5);

      .btn {
        width: rem(25);
        height: rem(25);
        border: rem(1) solid $dark-grey-background;

        &-icon {
          width: rem(13);
          height: rem(13);
          font-size: rem(13);
          margin-left: rem(-1);
          margin-bottom: rem(2);

          &:before { font-size: rem(13); }
        }
      }

      &--close {

        .btn {
          border: none;

          &-icon { margin-left: rem(-1); }
        }
      }
    }

    &[type='password'] {

      &.input--warning { border-color: $dark-grey-background; }

      &:focus {
        border-color: $pending-blue;

        &.input--warning { border-color: $pending-blue; }
      }
    }

    &--full-buttons { width: calc(100% - #{rem(60)}); }

    &--full { width: 100%; }

    &--toolbar {

      .input {
        border-color: $toolbar-input-background;
        background-color: $toolbar-input-background;
      }
    }

    &--disabled {
      cursor: not-allowed;
      color: $medium-grey-background;
      border-color: $disabled-border-color;

      &:hover {
        border-color: $disabled-border-color;
      }
    }
  }

  input.input--full, input.input--full-buttons { width: 100%; }

  .warning {
    width: rem(50);
    height: rem(50);
    right: 0;
    z-index: 10;
    display: flex;
    position: absolute;
    border-radius: 50%;
    align-items: center;
    justify-content: center;

    &__icon {
      width: rem(14);
      font-size: rem(14);
      background-color: $white;

      &:after {
        width: rem(50);
        height: rem(50);
        content: '';
      }
    }

    &__text {
      height: rem(25);
      color: $white;
      left: rem(40);
      @extend %shadow;
      padding: 0 rem(5);
      font-size: rem(11);
      position: absolute;
      white-space: nowrap;
      line-height: rem(25);
      border-radius: rem(2);

      &:after {
        width: 0;
        top: 50%;
        height: 0;
        right: 100%;
        content: '';
        border: solid;
        position: absolute;
        pointer-events: none;
        border-width: rem(5);
        margin-top: rem(-5);
        border-color: rgba(239, 152, 37, 0);
      }
    }

    &--large { padding: rem(18); }

    &--small {
      width: rem(13);
      height: rem(25);
      right: rem(5);
      padding: rem(5);

      .warning__icon {
        margin-top: rem(3);
        font-size: rem(13);
        background-color: $white;
      }

      .warning__text { left: rem(25); }
    }

    &--medium {
      width: rem(38);
      height: rem(38);
      right: rem(0);
      padding: rem(5);

      .warning__icon {
        margin-top: rem(3);
        font-size: rem(13);
        background-color: $white;
      }

      .warning__text {
        top: rem(6);
        left: rem(38);
      }
    }
  }

  .warning__bottom {

    &__text {
      display: inline-block;
      color: $error-red;
      height: rem(20);
      line-height: rem(20);
      font-size: rem(11);
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .warning {

      &--large {

        .warning__text { top: rem(13); }
      }

      &--small {

        .warning__icon {
          position: relative;
          display: inline-block;
          margin-right: rem(100);
        }

        .warning__text { top: 0; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Input.vue